import React, { useEffect, useRef, useState } from "react";
import "./CardThreeScreen.css";

export default function CardThreeScreen() {
  const ref = useRef<HTMLDivElement>(null);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [cardsVisible, setCardsVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            setTimeout(() => {
              setCardsVisible(true);
            }, 300);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [hasAnimated]);
  const cards = [
    {
      number: "01",
      title: "Ձևավորել լավ հարաբերություններ փողի հետ"
    },
    {
      number: "02",
      title: "Ազատվել պարտքերից"
    },
    {
      number: "03",
      title: "Ներդրումներ կատարել"
    },
    {
      number: "04",
      title: "Խելացի խնայել"
    },
    {
      number: "05",
      title: "Ստեղծել բյուջե"
    },
    {
      number: "06",
      title: "Լինել ֆինանսապես ապահով"
    },
  ];

  return (
    <div ref={ref} className={`card-three-screen ${hasAnimated ? 'animate' : ''}`}>
      <div className="card-three-grid">
        <div className={`card-three-item top-left ${cardsVisible ? 'visible' : ''}`}>
          <h3 className="card-number">{cards[0].number}</h3>
          <p className="card-title">{cards[0].title}</p>
        </div>

        <div className={`card-three-item top-right ${cardsVisible ? 'visible' : ''}`}>
          <h3 className="card-number">{cards[1].number}</h3>
          <p className="card-title">{cards[1].title}</p>
        </div>

        <div className={`card-three-center ${cardsVisible ? 'visible' : ''}`}>
          <h2 className="center-title">Դուք լավ տեղում եք եթե ցանկանում եք սովորել ինչպես…</h2>
        </div>

        <div className={`card-three-item middle-left ${cardsVisible ? 'visible' : ''}`}>
          <h3 className="card-number">{cards[2].number}</h3>
          <p className="card-title">{cards[2].title}</p>
        </div>

        <div className={`card-three-item middle-right ${cardsVisible ? 'visible' : ''}`}>
          <h3 className="card-number">{cards[3].number}</h3>
          <p className="card-title">{cards[3].title}</p>
        </div>

        <div className={`card-three-item bottom-left ${cardsVisible ? 'visible' : ''}`}>
          <h3 className="card-number">{cards[4].number}</h3>
          <p className="card-title">{cards[4].title}</p>
        </div>

        <div className={`card-three-item bottom-right ${cardsVisible ? 'visible' : ''}`}>
          <h3 className="card-number">{cards[5].number}</h3>
          <p className="card-title">{cards[5].title}</p>
        </div>
      </div>
      <div className="gradient-overlay"></div>
    </div>
  );
}
